import { render, staticRenderFns } from "./TradesLayout.vue?vue&type=template&id=84c2b868&scoped=true&"
import script from "./TradesLayout.vue?vue&type=script&lang=js&"
export * from "./TradesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c2b868",
  null
  
)

export default component.exports